<template>
  <div class="checkbox-select">
    <div
        @click="toggle"
        class="checkbox-select__label bg-sandgrey px-4 py-2"
        :class="{ clearable: clearable }"
    >
      <div class="label">{{ label }} {{ selectedItemText }}</div>
      <div
          v-if="clearable"
          class="icon-schliessen-klein clear-all"
          @click="clearAll"
      ></div>
    </div>

    <transition name="fade">
      <div
          v-if="show"
          v-click-outside="close"
          class="checkbox-select__container bg-sandgrey pa-4"
      >
        <div>
          <v-checkbox
              v-for="(item,i) in items"
              :key="i"
              :value="item.value"
              :label="item.text"
              v-model="tmpSelectedItems"
              hide-details
              style="margin-top: 8px;"
          />
        </div>

        <v-btn
            depressed
            small
            color="primary"
            class="mt-6 w-full"
            @click="accept"
        >
          {{ buttonText }}
        </v-btn>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CheckboxSelect",

  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      show: false,
      tmpSelectedItems: [],
      selectedItems: []
    }
  },

  computed: {
    selectedItemText() {
      let items = []

      this.items.forEach(item => {
        if (this.selectedItems.includes(item.value)) {
          items.push(item.text)
        }
      })

      return items.join(', ')
    }
  },

  methods: {
    toggle() {
      if(this.show) {
        this.close()
      } else {
        this.open()
      }
    },

    open() {
      this.show = true
      this.tmpSelectedItems = this.value
    },

    close() {
      this.show = false
      this.tmpSelectedItems = []
    },

    clearAll(e) {
      e.preventDefault()
      e.stopPropagation()
      this.tmpSelectedItems = []
      this.selectedItems = []
      this.$emit('input', this.selectedItems)
    },

    accept() {
      this.selectedItems = this.tmpSelectedItems
      this.$emit('input', this.selectedItems)
      this.close()
    }
  },

  mounted() {
    this.selectedItems = this.value
    this.tmpSelectedItems = this.value
  }
}
</script>

<style lang="scss" scoped>
.checkbox-select {
  position: relative;
  width: 200px;

  .checkbox-select__label {
    border-radius: 10px;
    cursor: pointer;

    &.clearable {
      display: flex;
      gap: 0.5rem;
      align-items: center;

      .label {
        flex: 1;
      }

      .clear-all {
        position: relative;
        cursor: pointer;
        z-index: 9;
        font-size: 12px;
        line-height: 22px;

        &:hover {
          color: #ce20a8;
        }
      }
    }

    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .checkbox-select__container {
    position: absolute;
    width: 100%;
    margin-top: 10px;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000029;
    z-index: 99;
  }
}
</style>
